import React from 'react';
import { motion } from 'framer-motion';
import { HiArrowDown } from 'react-icons/hi';
import { useLanguage } from '../i18n/LanguageContext';
import './Hero.css';

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="hero section" id="hero">
      <div className="container hero__content">
        <motion.div
          className="hero__text"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <motion.p
            className="hero__greeting"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <span className="hero__greeting-line" />
            {t('hero.greeting')}
          </motion.p>

          <motion.h1
            className="hero__name"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }}
          >
            Giuseppe<br />
            <span className="gradient-text">Monfregola</span>
          </motion.h1>

          <motion.h2
            className="hero__title"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.9 }}
          >
            {t('hero.title')}
          </motion.h2>

          <motion.p
            className="hero__description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1.1 }}
          >
            {t('hero.description')}
          </motion.p>

          <motion.div
            className="hero__actions"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1.3 }}
          >
            <a href="#projects" className="hero__btn hero__btn--primary">
              {t('hero.btnProjects')}
            </a>
            <a href="#contact" className="hero__btn hero__btn--secondary">
              {t('hero.btnContact')}
            </a>
          </motion.div>
        </motion.div>

        <motion.div
          className="hero__visual"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <div className="hero__code-window">
            <div className="hero__code-header">
              <span className="hero__code-dot hero__code-dot--red" />
              <span className="hero__code-dot hero__code-dot--yellow" />
              <span className="hero__code-dot hero__code-dot--green" />
              <span className="hero__code-filename">GameDev.cs</span>
            </div>
            <pre className="hero__code-body">
              <code>
{`public class GameDev : MonoBehaviour
{
    [SerializeField]
    private string name = "Giuseppe";

    private string[] skills = {
        "Unity", "C#", "Game Design",
        "React", "Problem Solving"
    };

    void Start()
    {
        Debug.Log("Ready to create!");
        BuildAmazingGames();
    }
}`}
              </code>
            </pre>
          </div>
        </motion.div>
      </div>

      <motion.a
        href="#about"
        className="hero__scroll"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 0.5 }}
      >
        <span>{t('hero.scroll')}</span>
        <HiArrowDown className="hero__scroll-icon" />
      </motion.a>
    </section>
  );
};

export default Hero;
